import { render, staticRenderFns } from "./Emphasis.vue?vue&type=template&id=4ddf18b6&scoped=true"
import script from "./Emphasis.vue?vue&type=script&lang=js"
export * from "./Emphasis.vue?vue&type=script&lang=js"
import style0 from "./Emphasis.vue?vue&type=style&index=0&id=4ddf18b6&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf18b6",
  null
  
)

export default component.exports